module.exports = __webpack_public_path__ + "static/media/Vestas logo_RGB_50.fc11ea2c.jpg";